module.exports = __webpack_public_path__ + "img/tmx-2.38a7363c.jpeg";